import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import jQuery from "jquery";
const $ = jQuery;

gsap.registerPlugin(SplitText, ScrollTrigger);

export default class Animations {
    constructor() {
        this.domMap();
    }

    domMap = () => {
        this.window = $(window);
        this.split = $('.split');
        this.splitWord = $('.split-word');
        this.splitLine = $('.split-line');
        this.fadeChar = $('.char-fade');
        this.fade = $('.fade');
        this.fadeUp = $('.fade-up');
        this.fadeUpSq = $('.fade-up-sq');
        this.stickyHeading = $('.product-comparision .sticky-title');
        this.stickyShare = $('.share-article');
        this.parallaxSections = $('.parallax-sections');

        if (this.fadeChar.length > 0) {
            this.characterFade(this.fadeChar);
        }
        if (this.fade.length > 0) {
            this.scrollTigglerFade(this.fade);
        }
        if (this.fadeUpSq.length > 0) {
            this.scrollTigglerYSq(this.fadeUpSq);
        }
        if (this.fadeUp.length > 0) {
            this.scrollTigglerY(this.fadeUp);
        }

        if (this.stickyHeading.length > 0) {
            this.skickyHead();
        }

        if (this.stickyShare.length > 0) {
            this.stickyShareEl();
        }

        if (this.parallaxSections.length > 0) {
            this.dualAnimation();
        }
    }

    skickyHead = () => {

        this.stickyHeading.each((i, el) => {
            const viewEl = el.parentElement;
            const elHeight = viewEl.clientHeight - 300;
            const featureTitle = viewEl.querySelector('.features');
            const stick = () => {
                const pin = ScrollTrigger.create({
                    trigger: viewEl,
                    pinSpacing: false,
                    invalidateOnRefresh: true,
                    pin: el, // pin the trigger element while active
                    start: 'top 90px', // when the top of the trigger hits the top of the viewport
                    end: `${elHeight}px`, // end after scrolling beyond the start
                    scrub: 1,
                    refreshPriority: 1,
                    onUpdate: (self) => {
                        if (self.progress.toFixed(3) > 0.046 && featureTitle != null) {
                            featureTitle.classList.add('opacity-0');
                        } else if (featureTitle != null) {
                            featureTitle.classList.remove('opacity-0');
                        }
                    }
                })

                return pin;
            }

            const animate = stick();

            window.addEventListener('resize', () => {
                animate.kill();
                setTimeout(() => {
                    stick()
                }, 200);
            })

        });


    }
    stickyShareEl = () => {
        const elHeight = this.stickyShare.height();
        // console.log(elHeight);
        // this.stickyHeading.each((i, el) => {
        //     const viewEl = el.parentElement;
        //     const elHeight = viewEl.clientHeight - 300;
        //     console.log(elHeight);

        //     ScrollTrigger.create({
        //         trigger: viewEl,
        //         pinSpacing: false, 
        //         invalidateOnRefresh: true,
        //         pin: el, // pin the trigger element while active
        //         start: 'top 85px', // when the top of the trigger hits the top of the viewport
        //         end: `${elHeight}px`, // end after scrolling 500px beyond the start
        //         scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        //         refreshPriority: 1
        //     })

        //     window.addEventListener('resize', () => {
        //         ScrollTrigger.refresh();
        //     })
        // });

    }




    characterFade = (element) => {
        const elm = gsap.utils.toArray(element);

        elm.forEach(tag => {
            const splits = new SplitText(tag, {
                type: "words, chars",
                wordsClass: "word",
                charsClass: "char",
                //position: "absolute"
            });

            const el = tag.querySelectorAll('.char');

            gsap.set(el, {
                opacity: 0,
            });

            const animate = gsap.timeline();

            animate.to(el, {
                opacity: 1,
                yPercent: 0,
                stagger: 0.05,
                /* onComplete: () => {
                    splits.revert()
                } */
            });

            ScrollTrigger.create({
                trigger: tag,
                start: "top 80%",
                invalidateOnRefresh: true,
                animation: animate,
            });
        });
    }


    scrollTigglerY = (element) => {
        const elm = gsap.utils.toArray(element);
        gsap.set(elm, {
            yPercent: 50,
            opacity: 0
        });
        elm.forEach(tag => {
            const animate = gsap.timeline();
            animate.to(tag, {
                opacity: 1,
                yPercent: 0,
                duration: 0.3,
            })

            ScrollTrigger.create({
                trigger: tag,
                start: "top 80%",
                invalidateOnRefresh: true,
                animation: animate,
            });
        });
    }

    scrollTigglerYSq = (element) => {
        const elm = gsap.utils.toArray(element);

        elm.forEach(tag => {
            const children = tag.querySelectorAll('.item-sq');
            const animate = gsap.timeline();
            gsap.set(children, {
                yPercent: 30,
                opacity: 0
            });
            animate.to(children, {
                opacity: 1,
                yPercent: 0,
                delay: 0.2,
                stagger: {
                    each: 0.2,
                    ease: "slow(0.7,0.7,false)",
                }
            })

            ScrollTrigger.create({
                trigger: tag,
                start: "top 80%",
                invalidateOnRefresh: true,
                animation: animate,
            });
        });
    }

    scrollTigglerFade = (element, duration) => {
        const elm = gsap.utils.toArray(element);
        let dur = duration ? duration : 1
        gsap.set(elm, {
            opacity: 0,
            delay: 0.2
        });
        elm.forEach(tag => {
            const animate = gsap.timeline();
            animate.to(tag, {
                opacity: 1,
                duration: dur,
            })

            ScrollTrigger.create({
                trigger: tag,
                start: "top 80%",
                invalidateOnRefresh: true,
                animation: animate,
            });
        });
    }

    dualAnimation = () => {
        const parallaxEl = gsap.utils.toArray(".parallax-sections");
        parallaxEl.forEach(section => {

            const firstAnimCounter = section.querySelector('.figure')
            const figuresSection = section.querySelector('.figures')
            const figures = section.querySelectorAll('.figures');
            const animCounter = section.querySelectorAll('.figures .item');
            const getWidth = section.querySelector('.figures .grid').clientWidth / 2;
            const callToAction = section.querySelector('.call-to-action-v2');
            const transition = section.querySelector('.transition');
            const btns = section.querySelectorAll('button.trigger-btn:not([data-toggle="modal"])');

            btns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const target = btn.getAttribute('data-target');
                    section.querySelector('.show') === null ? section.querySelector(`#${target}`).classList.add('show') : section.querySelector('.show')?.classList.remove('show')

                })
            });

            animCounter.forEach(item => {
                gsap.set(item, { opacity: .1, yPercent: 30 })
            })
            gsap.set([callToAction, transition], { opacity: .1 })
            // gsap.set(firstAnimCounter, {
            //     scale: window.matchMedia('(min-width: 768px)').matches ? 3 : 2,
            //     x: window.matchMedia('(min-width: 768px)').matches ? getWidth : getWidth / 2,
            //     y: window.matchMedia('(min-width: 768px)').matches ? -150 : 0
            // })

            const tl = gsap.timeline({
                delay: 1,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: section.querySelector('.figures'),
                    start: "100 60%",
                    pin: true,
                    end: "bottom 20%",
                    // end: "bottom 40%",
                    // endTrigger: callToAction,
                    // markers: true,
                    scrub: 1
                }
            })
            tl.to('.item', { opacity: 1, yPercent: 0, stagger: .1 })
            tl.to(transition, { opacity: 1, delay: 1 })
            // tl.to(figuresSection, { opacity: 1, xPercent: -50, delay: 1, stagger: 1 })
            tl.to(callToAction, { opacity: 1 }, "<")

            gsap.from(".animCounter", {
                textContent: "0",
                duration: 1.2,
                ease: "power1.inOut",
                modifiers: {
                    textContent: value => formatNumber(value, 0)
                },
                scrollTrigger: {
                    trigger: ".figures",
                    start: "100 bottom",
                    // start: "100px 80%",
                    end: "bottom 20%",
                    // end: "+=100",
                    toggleActions: "play none none reverse",
                    // markers: true,
                    scrub: 1
                }
            });
        });



        function formatNumber(value, decimals) {
            let s = (+value).toLocaleString('en-US').split(".");
            return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
        }
    }
}